import React, { useState } from "react";
import { Bar } from "react-chartjs-2";
import Select from "react-select";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// Registering chart components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const ArrearDashboard = () => {
  const [selectedMonth, setSelectedMonth] = useState("july");

  // Static arrear data for each month
  const arrearData = {
    july: [40.35, 2.91, 3.58, 4.58, 6.64, 5.92, 4.14, 2.50, 3.11, 26.26],
    august: [20.12, 3.01, 4.02, 5.32, 7.21, 6.78, 3.98, 2.88, 3.33, 28.15],
    september: [3.77, 3.33, 3.88, 4.92, 6.43, 6.12, 4.33, 2.65, 2.95, 26.62],
  };

  // Static net bill data for each month
  const netBillData = {
    july: [45, 5, 6, 7, 9, 8, 6, 4, 5, 30],
    august: [25, 5, 6, 8, 10, 9, 7, 5, 6, 32],
    september: [20, 6, 7, 9, 11, 10, 8, 5, 6, 28],
  };

  // Bar chart data based on selected month
  const dataArrears = {
    labels: ['0-10', '10-20', '20-30', '30-40', '40-50', '50-60', '60-70', '70-80', '80-90', '90-100'],
    datasets: [
      {
        label: `Arrear Amount for ${selectedMonth.charAt(0).toUpperCase() + selectedMonth.slice(1)}`,
        data: arrearData[selectedMonth],
        backgroundColor: '#664dc9', // Customize color
        borderWidth: 1,
      },
    ],
  };

  const dataNetBill = {
    labels: ['0-10', '10-20', '20-30', '30-40', '40-50', '50-60', '60-70', '70-80', '80-90', '90-100'],
    datasets: [
      {
        label: `Net Bill Amount for ${selectedMonth.charAt(0).toUpperCase() + selectedMonth.slice(1)}`,
        data: netBillData[selectedMonth],
        backgroundColor: '#ff9b44', // Customize color
        borderWidth: 1,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      y: {
        beginAtZero: true,
        max: 50,
        grid: {
          display: false,
        },
        ticks: {
          callback: function (value) {
            return value + "M"; // Append 'M' to the y-axis labels
          },
          font: {
            size: 12, // Customize the font size if needed
          },
        },
      },
      x: {
        barPercentage: 0.6,
        grid: {
          display: false,
        },
        title: {
          display: true,
          text: "Prediction Bucket",
          color: "#000",
          font: {
            size: 14,
            weight: "bold",
          },
        },
      },
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: function (context) {
            const label = context.dataset.label || "";
            const value = context.raw;
            return `${label}: ${value}M`; // Add 'M' after each number in the tooltip
          },
        },
      },
    },
  };
  
  
  

  // Custom styles for react-select
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#ff9b44" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "#ff9b44",
      },
    }),
    control: (provided) => ({
      ...provided,
      borderColor: "#ff9b44",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#ff9b44",
      },
    }),
  };

  // Define options for months
  const monthOptions = [
    { value: "july", label: "July 2024" },
    { value: "august", label: "August 2024" },
    { value: "september", label: "September 2024" },
  ];

  // Handle month selection change
  const handleMonthChange = (selectedOption) => {
    setSelectedMonth(selectedOption ? selectedOption.value : "july");
  };

  return (
    <div className="page-wrapper">

      <div className="content container-fluid">
      <div className="col">
              <h3 className="page-title">{"AI Analytics View"}</h3>
              <br />
            </div>
        {/* Arrear Filter */}
        <div className="row filter-row">
          {/* Month Filter Dropdown */}
          <div className="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
            <div className="input-block mb-3 form-focus select-focus">
              <Select
                options={monthOptions}
                onChange={handleMonthChange}
                placeholder="July 2024"
                styles={customStyles}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
              />
              <label className="focus-label"></label>
            </div>
          </div>
        </div>
        <br></br>
        {/* Arrear Bar Chart */}
        <div className="row">
          <div className="col-md-6">
            <div className="card">
              <div className="card-header">
                <div className="card-title">Arrear</div>
              </div>
              <div className="card-body">
                <div>
                  <Bar style={{ height: '300px' }} data={dataArrears} options={options} />
                </div>
              </div>
            </div>
          </div>

          {/* Net Bill Bar Chart */}
          <div className="col-md-6">
            <div className="card">
              <div className="card-header">
                <div className="card-title">Net Bill</div>
              </div>
              <div className="card-body">
                <div>
                  <Bar style={{ height: '300px' }} data={dataNetBill} options={options} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArrearDashboard;
